import { observer } from "@legendapp/state/react";
import { Page } from "_page/Page";
import { VStack } from "_ui/Box";
import { Outlet } from "react-router-dom";

const Layout = observer(() => {
    return (
        <Page>
            <VStack wFull>
                <Outlet/>
            </VStack>
        </Page>
    );
});

export default Layout;
